import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { CompanyProfileIncompleteModalComponent } from './components/company-profile-incomplete-modal/company-profile-incomplete-modal.component';

@NgModule({
  declarations: [CompanyProfileIncompleteModalComponent],
  imports: [CommonModule, TranslateModule, CustomModalModule],
  exports: [CompanyProfileIncompleteModalComponent],
})
export class CompanyProfileIncompleteModalModule {}
